import { useContext } from 'react';
import { AuthContext, AuthContextState } from '../contexts/AuthContext';

export default function useAuth(): AuthContextState {
  const context = useContext(AuthContext);

  return context;
}
